
import { Box, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';

import { translate } from '../../../i18n/functions';

import { GrowUpDown, UpperParentDiv } from './Styles';

type Props = {

    /**
     * Align Text.
     */
    align: ?string,

    /**
     * Children.
     */
    children: any,

    /**
     * Height of the dialog.
     */
     height: string,

    /**
     * Dialog Color String.
     */
    dialogColor: ?string,

    /**
     * IsOpen.
     */
     isOpen: ?boolean,

     /**
      * OnDialogHandle.
      */
      onDialogHandle: ?Function,

      /*
      urlFunction
       */
      urlFunction: ?Function,

      /**
       * OnTimeOutHandle.
       */
       onTimeOutHandle: ?Function,

      /**
       * Translation function.
       */
       t: Function

}


const useStyles = makeStyles(() => {
    return {
        signinLi: {
            '& a': {
                display: 'flex',
                backgroundColor: '#1acc8d',
                color: '#fff',
                padding: '7px 14px !important',
                borderRadius: '5px 5px 0px 0px',
                '&:hover': {
                    backgroundColor: '#334560'
                },
                '&:before': {
                    content: 'none !important'
                }
            }

        },
        upperDialog: { alignItems: 'center',
            width: '95px',
            justifyContent: 'center',
            display: 'flex',
            cursor: 'pointer',
            background: 'rgb(92,125,175)',
            textAlign: 'center',
            marginLeft: '10px',
            marginRight: '4px',
            color: '#fff',
            fontSize: '10px',
            borderRadius: '5px 5px 0px 0px' }
    };
});


/**
 * Upper Dialog.
 *
 * @returns {any}
 */
function UpperDialog({
    align,
    children,

    // height = '25%',
    isOpen,
    urlFunction,
    onTimeOutHandle,
    onDialogHandle,
    dialogColor,
    t
}: Props) {

    const [ upDown, setUpDown ] = useState(false);
    const elementRef = React.useRef();
    const isMounted = React.useRef(false);
    const divRef = React.useRef();

    // Mirror of the controlled `isOpen` prop so the body-click listener (which is
    // registered only once) can always read the current open state.
    const isOpenRef = React.useRef(false);
    const [ userHeight, setUserHeight ] = React.useState(0);
    const [ dialogHeight, setDialogHeight ] = React.useState('0');
    const styles = useStyles();

    // The parent (Conference) is the single source of truth for the open state.
    // This effect only runs the open/close animation in response to the
    // controlled `isOpen` prop. It must NOT call onDialogHandle(); doing so used
    // to create a feedback loop where the dialog reopened right after being
    // closed (and only closed on the second click).
    React.useEffect(() => {
        isOpenRef.current = isOpen === true;

        if (isOpen === true) {
            if (!upDown) {
                animateOpen();
            }
        } else if (upDown) {
            animateClose();
        }

        isMounted.current = true;
    }, [ JSON.stringify(isOpen) ]);

    /**
     * Runs the open animation. Does not notify the parent.
     *
     * @returns {void}
     */
    function animateOpen() {
        setUpDown(true);
        setUserHeight('25%');
        setTimeout(() => {
            setDialogHeight('auto');

            // divRef.current.height = '100vh';
        }, 500);
    }

    /**
     * Runs the close animation. Does not notify the parent.
     *
     * @returns {void}
     */
    function animateClose() {
        setUpDown(false);
        setDialogHeight('0');
        setTimeout(() => {
            setUserHeight(0);
            onTimeOutHandle && onTimeOutHandle(15000);
        }, 500);
    }

    /**
     * Handles a user click on the open/close ad toggle. Asks the parent to flip
     * the dialog state; the animation runs from the `isOpen` effect above.
     *
     * @param {Object} [e] - Click event.
     * @returns {void}
     */
    function setOpen(e) {
        // Prevent event bubbling to body click listener
        if (e) {
            e.stopPropagation();
        }

        onDialogHandle();
    }

    React.useEffect(() => {
        const myElementToCheckIfClicksAreInsideOf = document.querySelector('#idd');

        const handleBodyClick = e => {
            // Only react to outside clicks while the dialog is actually open and
            // ask the parent to close it (single source of truth).
            if (isOpenRef.current && myElementToCheckIfClicksAreInsideOf && !myElementToCheckIfClicksAreInsideOf.contains(e.target)) {
                onDialogHandle();
            }
        };

        document.body.addEventListener('click', handleBodyClick);

        // Cleanup listener on unmount
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);

    const setIcon = () => {
        if (align !== 'top') {
            if (upDown) {
                return t('dialog.closeAd');
            }

            return t('dialog.openAd');
        }

        if (upDown) {
            return t('dialog.closeAd');
        }


        return t('dialog.openAd');
    };


    return (
        <div
            id = 'idd'
            ref = { elementRef }>
            <UpperParentDiv
                height = { userHeight }>
                <GrowUpDown
                    dialogColor = { dialogColor }
                    height = { dialogHeight }
                    id = 'growUpDown'
                    innerRef = { divRef }>
                    { children }
                </GrowUpDown>
                {
                    <Box display = { 'flex' }>
                        <div
                            className = { styles.upperDialog }
                            onClick = { setOpen }>
                            { setIcon() }
                        </div>
                        { urlFunction && <div className = { styles.signinLi }>
                            <a
                                href = { urlFunction() }
                                rel = 'noopener noreferrer'
                                target = '_blank'>
                                {t('dialog.removeAds')}
                            </a>
                        </div>}
                    </Box>

                }
            </UpperParentDiv>

        </div>
    );
}

export default translate(UpperDialog);
